import '@/scss/pages/scholarship-program.scss'
import 'intl-tel-input/build/css/intlTelInput.css'
import { useSidebarBottom } from '@/js/common/sidebar-bottom'
import useFAQ from '@/js/section/pricing/faq'

import header from '../layout/header'
import anchor from '../common/anchor'
import setPhoneMask from '../common/phone-mask'
import setFilesChange from '../section/scholarship-program/file'
import initThankYouPopup from '../section/scholarship-program/thank-you-popup'
import validateContactField from '../common/validate-contact-field'

document.addEventListener('DOMContentLoaded', function () {
  header()
  anchor()
  useFAQ()
  setPhoneMask()
  setFilesChange()
  initThankYouPopup()
  validateContactField()
  useSidebarBottom()
})
